import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

const SLICE_NAME = 'currencyDetails';
const GET_CURRENCY_DETAILS = SLICE_NAME + '/get';
const ADD_CURRENCY_DETAILS = SLICE_NAME + '/add';
const UPDATE_CURRENCY_DETAILS_SOURCE = SLICE_NAME + '/{id}/update';
const DELETE_CURRENCY_DETAILS_SOURCE = SLICE_NAME + '/{id}/delete';
const INVALIDATE_CURRENCY_DETAILS_CACHE = SLICE_NAME + '/invalidateCache';

export const getCurrencyDetails = createAsyncThunk(
  GET_CURRENCY_DETAILS,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get('/currencydetails');
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const addCurrencyDetails = createAsyncThunk(
  ADD_CURRENCY_DETAILS,
  async ({ payload, headers }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.post('/currencydetails', payload, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateCurrencyDetails = createAsyncThunk(
  UPDATE_CURRENCY_DETAILS_SOURCE,
  async ({ payload, id, headers }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.put(`/currencydetails/${id}`, payload, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const deleteCurrencyDetails = createAsyncThunk(
  DELETE_CURRENCY_DETAILS_SOURCE,
  async ({ id, headers }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.delete(`/currencydetails/${id}`, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const invalidateCache = createAsyncThunk(
  INVALIDATE_CURRENCY_DETAILS_CACHE,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get('/currencydetails/invalidatecache');
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const configSlice = createSlice({
  name: SLICE_NAME,
  initialState: {
    list: [],
  },
  reducers: {},
  extraReducers: {
    [getCurrencyDetails.fulfilled]: (state, { payload }) => {
      state.list = payload;
    },
    [addCurrencyDetails.fulfilled]: (state, { payload }) => {
      if (payload.status !== 'Created') {
        return;
      }

      const newToggle = payload.data;
      state.list.push(newToggle);
    },
    [updateCurrencyDetails.fulfilled]: (state, { payload }) => {
      if (payload.status !== 'OK') {
        return;
      }

      const updatedId = payload.data && payload.data.id;
      const data = [...state.list];
      const updateIndex = data.findIndex((config) => config.id === updatedId);

      if (updateIndex !== -1) {
        data[updateIndex] = { ...payload.data };
        state.list = [...data];
      }
    },
    [deleteCurrencyDetails.fulfilled]: (state, { payload }) => {
      if (payload.status !== 'OK') {
        return;
      }

      const data = [...state.list];
      const deletedId = payload.id;
      const deletedIndex = data.findIndex((config) => config.id === deletedId);
      data.splice(deletedIndex, 1);
      state.list = [...data];
    },
  },
});

export const configActions = configSlice.actions;

export const selectCurrencyDetailsList = (state) => state.currencyDetails.list;

export default configSlice.reducer;
